import Swiper from 'swiper/bundle'

function announcementsSlider() {
  const slider = document.querySelector('[data-name="announcements-slider"]')

  if (slider) {
    const slides = slider.querySelectorAll('.swiper-slide')
    const wrapper = slider.querySelector('.swiper-wrapper')

    if (window.innerWidth < 700) {
      wrapper.style.flexDirection = 'column'
      wrapper.style.justifyContent = 'center'
      wrapper.style.alignItems = 'center'
      wrapper.classList.remove('container')
      wrapper.querySelectorAll('a').forEach((a) => {})
    } else {
      wrapper.style.flexDirection = 'row'
    }

    if (slides.length >= 3) {
      if (window.innerWidth > 767) {
        slider.classList.add('swiper')
        wrapper.classList.remove('container')
        wrapper.classList.remove('gap-30')
        wrapper.classList.remove('justify-center')
        wrapper.classList.remove('items-center')

        const announcementsSlider = new Swiper(slider, {
          slidesPerView: 2.5,
          initialSlide: 1,
          spaceBetween: 30,
          centeredSlides: true,
        })
      }
    }
  }
}

export default announcementsSlider
